import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  getAllSectionsApi,
  deleteSectionApi,
  getSectionBinApi,
  restoreSectionApi,
} from "../../Constants/api";
import SweetAlert from "react-bootstrap-sweetalert";
import Table from "../../../../../../Components/Table";

const AllSections = () => {
  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10);
  const [alert, setAlert] = useState(null);
  const [isBin, setIsBin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const fetchData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    try {
      const response = isBin
        ? await getSectionBinApi(page, sizePerPage)
        : await getAllSectionsApi(page, sizePerPage);

      if (response?.data) {
        setData(response.data.data || []);
        setTotalItems(response.data.count || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activePage, itemsCountPerPage);
  }, [activePage, itemsCountPerPage, isBin]);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setActivePage(page);
    setItemsCountPerPage(sizePerPage);
  };

  const handleDelete = async (id) => {
    try {
      await deleteSectionApi(id);
      setAlert(
        <SweetAlert
          success
          title="Deleted!"
          onConfirm={() => {
            setAlert(null);
            fetchData(activePage, itemsCountPerPage);
          }}
        >
          Section has been deleted.
        </SweetAlert>
      );
    } catch (error) {
      console.error("Error deleting:", error);
      setAlert(
        <SweetAlert
          danger
          title="Error!"
          onConfirm={() => setAlert(null)}
        >
          Something went wrong.
        </SweetAlert>
      );
    }
  };

  const handleRestore = async (id) => {
    try {
      await restoreSectionApi(id);
      setAlert(
        <SweetAlert
          success
          title="Restored!"
          onConfirm={() => {
            setAlert(null);
            fetchData(activePage, itemsCountPerPage);
          }}
        >
          Section has been restored.
        </SweetAlert>
      );
    } catch (error) {
      console.error("Error restoring:", error);
      setAlert(
        <SweetAlert
          danger
          title="Error!"
          onConfirm={() => setAlert(null)}
        >
          Something went wrong.
        </SweetAlert>
      );
    }
  };


  const confirmDelete = (id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => handleDelete(id)}
        onCancel={() => setAlert(null)}
        focusCancelBtn
      >
        You will not be able to recover this section!
      </SweetAlert>
    );
  };

  const confirmRestore = (id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, restore it!"
        confirmBtnBsStyle="success"
        title="Are you sure?"
        onConfirm={() => handleRestore(id)}
        onCancel={() => setAlert(null)}
        focusCancelBtn
      >
        You want to restore this section!
      </SweetAlert>
    );
  };


  const columns = [
    {
      text: "S.No",
      dataField: "sno",
      formatter: (cell, row, rowIndex) => {
        return (activePage - 1) * itemsCountPerPage + rowIndex + 1;
      },
    },
    {
      text: "Title",
      dataField: "title",
      formatter: (cell) => cell?.length > 10 ? cell.substring(0, 10) + "..." : cell
    },
    {
      text: "Description",
      dataField: "description",
      formatter: (cell) => cell?.length > 50 ? cell.substring(0, 50) + "..." : cell
    },
    {
      text: "Actions",
      dataField: "actions",
      formatter: (cell, row) => (
        <div>
          {!isBin ? (
            <>
              <button
                className="btn btn-primary btn-sm mr-2"
                onClick={() => history.push(`/dashboard/sections/edit/${row._id}`)}
              >
                Edit
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => confirmDelete(row._id)}
              >
                Delete
              </button>
            </>
          ) : (
            <button
              className="btn btn-success btn-sm"
              onClick={() => confirmRestore(row._id)}
            >
              Restore
            </button>
          )}

        </div>
      ),
    },
  ];

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3>{isBin ? "Section Bin" : "All Sections"}</h3>
        <div>
          <button className={`btn ${isBin ? 'btn-secondary' : 'btn-info'} mr-2`} onClick={() => { setIsBin(!isBin); setActivePage(1); }}>
            {isBin ? "View Active" : "View Bin"}
          </button>
          {!isBin && (
            <Link to="/dashboard/sections/create" className="btn btn-warning">
              Create New
            </Link>
          )}
        </div>
      </div>
      <div className="card-body">
        <Table
          rows={data}
          columns={columns}
          page={activePage}
          sizePerPage={itemsCountPerPage}
          totalSize={totalItems}
          onTableChange={handleTableChange}
          isLoading={isLoading}
        />
      </div>
      {alert}
    </div>
  );
};

export default AllSections;
